import { NumberUtils } from './number.utils';

export class MeasurementUtils {
  static convert(base: string, target: string, unitSize: number, value: number): number {
    if (!value) return value; // includes 0
    if (base === target) return value;
    if (!base || base === 'N/A') return value;
    if (!target || target === 'N/A') return value;
    if (Number.isNaN(value)) return value;
    switch (base) {
      case '%':
        return MeasurementUtils.percentTo(target, unitSize, value);
      case 'mg':
        return MeasurementUtils.mgTo(target, unitSize, value);
      case 'mg/g':
        return MeasurementUtils.mgPerGramTo(target, unitSize, value);
      case 'mg/ml':
        return MeasurementUtils.mgPerMlTo(target, unitSize, value);
    }
    return value;
  }

  /* **************************** percent to other units **************************** */

  static percentTo(target: string, unitSize: number, value: number): number {
    if (target === 'mg') {
      return MeasurementUtils.percentToMg(value, unitSize);
    } else if (target === 'mg/g') {
      return MeasurementUtils.percentToMgPerGram(value);
    } else if (target === 'mg/ml') {
      return MeasurementUtils.percentToMgPerMl(value);
    } else {
      return value;
    }
  }

  static percentToMg(value: number, unitSize: number): number {
    if (unitSize > 0) {
      const mgPerUnit = value * 10;
      return NumberUtils.roundToTwoDecimalPlaces(mgPerUnit * unitSize);
    } else {
      return value;
    }
  }

  static percentToMgPerGram(value: number): number {
    return NumberUtils.roundToTwoDecimalPlaces(value * 10);
  }

  static percentToMgPerMl(value: number): number {
    return NumberUtils.roundToTwoDecimalPlaces(value * 10);
  }

  /* **************************** mg to other units **************************** */

  static mgTo(target: string, unitSize: number, value: number): number {
    if (target === '%') {
      return MeasurementUtils.mgToPercent(value, unitSize);
    } else if (target === 'mg/g') {
      return MeasurementUtils.mgToMgPerGram(value, unitSize);
    } else if (target === 'mg/ml') {
      return MeasurementUtils.mgToMgPerMl(value, unitSize);
    } else {
      return value;
    }
  }

  static mgToPercent(value: number, unitSize: number): number {
    if (unitSize > 0) {
      const mgPerUnit = value / unitSize;
      const percent = mgPerUnit / 10;
      return NumberUtils.roundToTwoDecimalPlaces(percent);
    } else {
      return value;
    }
  }

  static mgToMgPerGram(value: number, unitSize: number): number {
    if (unitSize > 0) {
      const mgPerGram = value / unitSize;
      return NumberUtils.roundToTwoDecimalPlaces(mgPerGram);
    }
    return value;
  }

  static mgToMgPerMl(value: number, unitSize: number): number {
    if (unitSize > 0) {
      const mgPerMl = value / unitSize;
      return NumberUtils.roundToTwoDecimalPlaces(mgPerMl);
    }
    return value;
  }

  /* **************************** Mg/g to Other Units **************************** */

  static mgPerGramTo(target: string, unitSize: number, value: number): number {
    if (target === '%') {
      return MeasurementUtils.mgPerGramToPercent(value);
    } else if (target === 'mg') {
      return MeasurementUtils.mgPerGramToMg(value, unitSize);
    } else if (target === 'mg/ml') {
      return MeasurementUtils.mgPerGramToMgPerMl(value, unitSize);
    } else {
      return value;
    }
  }

  static mgPerGramToPercent(value: number): number {
    return NumberUtils.roundToTwoDecimalPlaces(value / 10);
  }

  static mgPerGramToMg(value: number, unitSize: number): number {
    if (unitSize > 0) {
      const mg = value * unitSize;
      return NumberUtils.roundToTwoDecimalPlaces(mg);
    }
    return value;
  }

  static mgPerGramToMgPerMl(value: number, unitSize: number): number {
    if (unitSize > 0) {
      const mgPerMl = value * unitSize;
      return NumberUtils.roundToTwoDecimalPlaces(mgPerMl);
    }
    return value;
  }

  /* **************************** Mg/ml to Other Units **************************** */

  static mgPerMlTo(target: string, unitSize: number, value: number): number {
    if (target === '%') {
      return MeasurementUtils.mgPerMlToPercent(value);
    } else if (target === 'mg') {
      return MeasurementUtils.mgPerMlToMg(value, unitSize);
    } else if (target === 'mg/g') {
      return MeasurementUtils.mgPerMlToMgPerGram(value, unitSize);
    } else {
      return value;
    }
  }

  static mgPerMlToPercent(value: number): number {
    return NumberUtils.roundToTwoDecimalPlaces(value / 10);
  }

  static mgPerMlToMg(value: number, unitSize: number): number {
    if (unitSize > 0) {
      const mg = value * unitSize;
      return NumberUtils.roundToTwoDecimalPlaces(mg);
    }
    return value;
  }

  static mgPerMlToMgPerGram(value: number, unitSize: number): number {
    if (unitSize > 0) {
      const mgPerGram = value * unitSize;
      return NumberUtils.roundToTwoDecimalPlaces(mgPerGram);
    }
    return value;
  }
}
